<div class="invoice-upload">

  <!-- Drop zone -->
  <div
    class="invoice-upload__drop-zone"
    [class.is-dragging]="isDragging"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()"
    role="button"
    tabindex="0"
    (keydown.enter)="fileInput.click()"
    [attr.aria-label]="'Upload invoice files. Click or drag and drop PDF, PNG or JPEG files.'">
    <div class="invoice-upload__icon-wrap">
      <mat-icon>cloud_upload</mat-icon>
    </div>
    <p class="invoice-upload__primary-text">
      <strong>Drag &amp; drop</strong> your invoice file(s) here,
      or <span class="invoice-upload__browse">click to browse</span>
    </p>
    <p class="invoice-upload__hint">
      <span>PDF, PNG, JPEG</span>
      <span class="dot"></span>
      <span>Max 2 MB per file</span>
      <span class="dot"></span>
      <span>5 MB total</span>
      <span class="dot"></span>
      <span>up to {{ maxFiles }} files</span>
    </p>
    <input
      #fileInput
      type="file"
      [accept]="'application/pdf,image/png,image/jpeg'"
      [multiple]="true"
      (change)="onFileSelected($event)"
      style="display:none" />
  </div>

  <p class="invoice-upload__pre-fill-note">
    <mat-icon>auto_awesome</mat-icon>
    <span>Fields below are pre-filled from the uploaded invoice(s) and remain editable.</span>
  </p>

  <!-- Reading / Parsing indicator -->
  <div *ngIf="isProcessing || isParsing" class="invoice-upload__parsing-indicator">
    <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
    <span *ngIf="isProcessing && !isParsing">Reading file(s)…</span>
    <span *ngIf="isParsing">Extracting invoice fields with AI…</span>
  </div>

  <!-- Validation errors -->
  <div *ngIf="validationErrors.length > 0" class="invoice-upload__errors">
    <span *ngFor="let err of validationErrors" class="error-message">{{ err }}</span>
  </div>

  <!-- AI extraction outcome -->
  <div *ngIf="hasParseWarning" class="invoice-upload__parse-warning" role="alert">
    <mat-icon>error_outline</mat-icon>
    <div class="parse-warning__body">
      <span class="parse-warning__title">{{ parseWarningTitle }}</span>
      <span class="parse-warning__detail">{{ parseWarningDetail }}</span>
    </div>
    <button
      mat-stroked-button
      type="button"
      class="parse-warning__retry"
      (click)="onRetryParse()">
      <mat-icon>refresh</mat-icon>
      Try again
    </button>
  </div>

  <!-- File list -->
  <div *ngIf="pendingFiles.length > 0" class="invoice-upload__file-list">
    <div
      *ngFor="let file of pendingFiles; let i = index"
      class="invoice-upload__file-item"
      [class.is-parse-failed]="isFileParseFailed(file.filename)">
      <div class="file-info">
        <div class="file-icon">
          <mat-icon>{{ mimeIcon(file.mimeType) }}</mat-icon>
        </div>
        <div class="file-meta">
          <span class="file-name" [matTooltip]="file.filename">{{ file.filename }}</span>
          <span class="file-size">{{ file.sizeLabel }}</span>
        </div>
      </div>
      <div class="file-actions">
        <span
          *ngIf="isFileParseFailed(file.filename)"
          class="file-status"
          matTooltip="No fields could be extracted from this file — enter its details manually.">
          <mat-icon>warning_amber</mat-icon>
          <span>not read</span>
        </span>
        <button
          mat-icon-button
          type="button"
          [matTooltip]="'Remove ' + file.filename"
          (click)="removeFile(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="parsedCount > 0" class="invoice-upload__ai-badge">
      <mat-icon>auto_awesome</mat-icon>
      <span>Invoice fields extracted automatically using AI</span>
    </div>
  </div>

</div>
